import React from 'react';
import { XIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function TruthSection() {
  const truths = ['fugas invisibles', 'decisiones sin plan', 'un presupuesto que no se adapta a tu realidad', 'deuda sin estrategia', 'cero automatización'];
  return <section className="py-20 relative" data-id="element-291">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-292">
        <FadeIn data-id="element-293">
          <div className="text-center mb-16" data-id="element-294">
            <span className="text-gold-500 font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-295">
              La verdad incómoda (pero liberadora)
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-296">
              Tu problema no es que "no ganes suficiente"
            </h2>
            <p className="text-xl text-slate-400 italic" data-id="element-297">
              (aunque claro que ayuda).
            </p>
          </div>
        </FadeIn>

        <div className="bg-red-950/20 border border-red-900/30 rounded-2xl p-8 md:p-12 mb-12" data-id="element-298">
          <FadeIn delay={0.2} data-id="element-299">
            <h3 className="text-2xl font-bold text-white mb-8 text-center" data-id="element-300">
              Tu problema es:
            </h3>
          </FadeIn>

          <div className="space-y-4 max-w-2xl mx-auto" data-id="element-301">
            {truths.map((truth, index) => <FadeIn key={index} delay={0.3 + index * 0.1} direction="right" data-id="element-302">
                <div className="flex items-center gap-4 bg-navy-900/50 p-4 rounded-lg border border-white/5" data-id="element-303">
                  <div className="bg-red-500/20 p-1 rounded text-red-400" data-id="element-304">
                    <XIcon className="w-5 h-5" data-id="element-305" />
                  </div>
                  <p className="text-lg text-slate-200 font-medium" data-id="element-306">{truth}</p>
                </div>
              </FadeIn>)}
          </div>
        </div>

        <FadeIn delay={0.8} data-id="element-307">
          <div className="text-center" data-id="element-308">
            <p className="text-2xl md:text-3xl font-bold text-gold-400" data-id="element-309">
              Y todo eso se arregla con un sistema.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}